module.exports = __webpack_public_path__ + "img/testimonial-image.7096a95c.png";